/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: e3531de3df84
 */

import * as z from "zod";
import { ApiError, ApiError$zodSchema } from "./apierror.js";
import {
  StreamingProfileListResponse,
  StreamingProfileListResponse$zodSchema,
} from "./streamingprofilelistresponse.js";

export type GetStreamingProfilesGlobals = { cloud_name?: string | undefined };

export const GetStreamingProfilesGlobals$zodSchema: z.ZodType<
  GetStreamingProfilesGlobals
> = z.object({
  cloud_name: z.string().describe("The cloud name of your product environment.")
    .optional(),
});

export type GetStreamingProfilesRequest = {};

export const GetStreamingProfilesRequest$zodSchema: z.ZodType<
  GetStreamingProfilesRequest
> = z.object({});

export type GetStreamingProfilesResponse =
  | StreamingProfileListResponse
  | ApiError;

export const GetStreamingProfilesResponse$zodSchema: z.ZodType<
  GetStreamingProfilesResponse
> = z.union([
  StreamingProfileListResponse$zodSchema,
  ApiError$zodSchema,
]);
